import { HTMLAttributes, ReactNode, useEffect, useState } from 'react'
import Cookies from 'js-cookie'

type HubSpotCTATestProps = HTMLAttributes<HTMLDivElement> & {
  id: string
  children: ReactNode[]
  persist?: boolean
}

const ABN = ({ children, id, persist, ...rest }: HubSpotCTATestProps) => {
  const [selectedChildIndex, setSelectedChildIndex] = useState<number | null>(
    null,
  )

  useEffect(() => {
    const cookieName = `hm_abn_${id}`
    let storedIndex = persist ? Cookies.get(cookieName) : null

    if (!storedIndex) {
      const randomIndex = Math.floor(Math.random() * children.length)
      if (persist) {
        Cookies.set(cookieName, String(randomIndex), { expires: 30 })
      }
      storedIndex = String(randomIndex)
    }

    setSelectedChildIndex(parseInt(storedIndex, 10))
  }, [id, children.length, persist])

  if (selectedChildIndex === null) return null

  return <div {...rest}>{children[selectedChildIndex]}</div>
}

export default ABN
